import { PRINCIPLES_EN, GOVERNANCE_CLOSING_EN } from "./principles.en";

export const getPrinciples = (lang) => (lang === "en" ? PRINCIPLES_EN : PRINCIPLES);
export const getGovernanceClosing = (lang) => (lang === "en" ? GOVERNANCE_CLOSING_EN : GOVERNANCE_CLOSING);

export const PRINCIPLES = [
  { num: "01", title: "Autorización y finalidad", desc: "Autorización y finalidad definidas antes de cualquier captura de datos." },
  { num: "02", title: "Mínimo privilegio", desc: "Mínimo privilegio y compartimentación en todos los accesos y flujos." },
  { num: "03", title: "Cifrado", desc: "Cifrado en tránsito y en reposo cuando corresponda al alcance." },
  { num: "04", title: "Integridad de registros", desc: "Integridad de registros y sincronización temporal verificable." },
  { num: "05", title: "Control de versiones", desc: "Control de versiones y de cambios sobre cada componente desplegado." },
  { num: "06", title: "Trazabilidad", desc: "Trazabilidad de consultas, decisiones y exportaciones." },
  { num: "07", title: "Segregación", desc: "Segregación entre operación, administración, auditoría y evidencia." },
  { num: "08", title: "Retención definida", desc: "Retención y eliminación definidas por alcance, no por defecto." },
  { num: "09", title: "Validación humana", desc: "Validación humana de los resultados automatizados antes de decidir." },
  { num: "10", title: "Respuesta ante incidentes", desc: "Respuesta ante incidentes y revisión continua de controles." },
  { num: "11", title: "Privacidad desde el diseño", desc: "Privacidad desde el diseño en producto, arquitectura e implantación." },
  { num: "12", title: "Cadena de custodia", desc: "Cadena de custodia cuando exista evidencia que preservar." },
];

export const GOVERNANCE_CLOSING =
  "La integración se diseña desde la identidad, la finalidad y el control. No desde la acumulación indiscriminada de datos.";
